$(document).ready(function(){  
   $(".txtEditor").Editor();        
    $('#userMail').on('shown', function(){
        $('#textarea').wysihtml5();
    });

    $('#userMail').on('hidden', function(){
        $('.wysihtml5-sandbox, .wysihtml5-toolbar').remove();
        $('#textarea').show();
    });
    
    $(".inbox-cc").click(function () {
        $(this).hide();
        $(".input-cc").show();
        
    });
    $(".input-cc .close").click(function () {
        $(this).parent().hide();
        $(".inbox-cc").show();
       
    });
    $(".inbox-bcc").click(function () {
        $(this).hide();
        $(".input-bcc").show();
        
    });
    $(".input-bcc .close").click(function () {
        $(this).parent().hide();
        $(".inbox-bcc").show();
        
    });
    
});

window.uploadFile = new Vue({
    el: "#userMail",
    data: {
        message: "",
        mailData: {to: '', cc: '', bcc: '', subject: '', content: ''},
        attachaments: {},
        formData: new FormData(),
        files: []
    },
    computed: {
       isEmpty: function (obj) {
          return $.isEmptyObject(obj);
       }
    },
    methods: {
        sendMail: function(e){
            var isValid = validate.sendEmailValidation('mail');
            if (!isValid) {
                return false;
            }
            this.mailData.content = $('#contentarea').html();
            this.mailData.attachments = (this.mailData.attached_files !== undefined && this.mailData.attached_files.length > 0 ) ? this.mailData.attached_files.join(',') : '';
            this.$http.post('/send/email', this.mailData).then((response) => {
                if (!response.body.hasError) {
                    toastr["success"](response.body.message);
                    this.mailData = {to: '', cc: '', bcc: '', subject: '', content: ''};
                    $('#contentarea').html("");
                    this.files = [];
                } else {
                    toastr["error"](response.body.message);
                }
                return false;
            }, (response) => {
                toastr["error"]("Something went wrong!", "FAILED!");
            });
        },
        uploadFile: function(e){
            var files = e.target.files || e.dataTransfer.files;
            var files = this.$refs.file_input.files;
            var data = new FormData();
            for (var i = 0; i < files.length; i++) {
                files[i]['id'] = i;
                data.append('attachments[]', files[i]);
            }
            this.$http.post('/uploadfile', data).then((response) => {
                if (!response.body.hasError) {
                    var file_attachments = (this.mailData.attached_files !== undefined) ? this.mailData.attached_files : [];
                    var file_count = this.files.length;
                    var i, j;
                    for (i = file_count, j = 0; j < response.body.message.length; i++, j++) {
                        var image = response.body.message[j];
                        var filename = image.originalname.substring(0,10)+"...";
                        file_attachments.push(image.path+image.name);
                        this.$set(this.files,i,image);
                    }
                    if(file_attachments !== undefined){
                        this.$set(this.mailData, 'attached_files',file_attachments);
                    }
                } 
                return false;
            }, (response) => {
                toastr["error"]("Upload failed, try again!", "FAILED!");
            });
        },
        removeUpload: function(image_id){ 
            this.$delete(this.mailData.attached_files,image_id);
            this.$delete(this.files,image_id);
        }
    }
});